import { v4 as uuidv4 } from 'uuid'

import AwsIcon from 'assets/images/spons/aws.svg'
import AuaIcon from 'assets/images/spons/aua.png'
import GridIcon from 'assets/images/spons/grid.png'
import AdobeIcon from 'assets/images/spons/adobe.png'
import DasMetaIcon from 'assets/images/spons/dasmeta.png'
import JetBrainsIcon from 'assets/images/spons/jetBrains.png'

import { SponsorCardInfo } from 'components/containers/Sponsors/SponsorCard'

const sponsorsData2025: SponsorCardInfo[] = [
  {
    id: uuidv4(),
    categoryName: 'PLATINUM',
    sponsors: [
      {
        id: uuidv4(),
        url: 'https://www.jetbrains.com/',
        image: JetBrainsIcon,
        name: 'jetbrains',
        vacantions: [
          {
            id: uuidv4(),
            title: 'DevOps Engineer',
            url: 'https://www.jetbrains.com/careers/jobs/devops-engineer-1664/',
          },
          {
            id: uuidv4(),
            title: 'DevOps Engineer (Data Office)',
            url: 'https://www.jetbrains.com/careers/jobs/devops-engineer-data-office-1668/',
          },
        ],
      },
      {
        id: uuidv4(),
        url: 'https://www.dasmeta.com/',
        image: DasMetaIcon,
        vacantions: undefined,
      },
      {
        id: uuidv4(),
        url: 'https://www.griddynamics.com/',
        image: GridIcon,
        name: 'griddynamics',
        vacantions: [
          {
            id: uuidv4(),
            title: 'Senior DevOps Engineer',
            url: 'https://www.griddynamics.com/careers/vacancy/24598',
          },
          {
            id: uuidv4(),
            title: 'Staff Software Engineer (Java)',
            url: 'https://www.griddynamics.com/careers/vacancy/24597',
          },
          {
            id: uuidv4(),
            title: 'Senior Big Data Engineer',
            url: 'https://www.griddynamics.com/careers/vacancy/16061',
          },
          {
            id: uuidv4(),
            title: 'Senior/Staff AI engineer',
            url: 'https://www.griddynamics.com/careers/vacancy/24632',
          },
          {
            id: uuidv4(),
            title: 'Java Back-End/Data Engineer',
            url: 'https://www.griddynamics.com/careers/vacancy/24333',
          },
        ],
      },
    ],
  },
  {
    id: uuidv4(),
    categoryName: 'GOLD',
    sponsors: [
      {
        id: uuidv4(),
        url: 'https://www.adobe.com/',
        image: AdobeIcon,
        name: 'adobe',
        vacantions: [
          {
            id: uuidv4(),
            title: 'Experience Design Manager',
            url: 'https://careers.adobe.com/us/en/job/R155019/Experience-Design-Manager',
          },
        ],
      },
    ],
  },
  {
    id: uuidv4(),
    categoryName: 'SPECIAL',
    sponsors: [
      {
        id: uuidv4(),
        url: 'https://cse.aua.am/',
        image: AuaIcon,
        name: 'aua',
        vacantions: [
          {
            id: uuidv4(),
            title: 'ERC Coordinator',
            url: 'https://jobs.aua.am/en/Position/1133',
          },
        ],
      },
      {
        id: uuidv4(),
        url: 'https://aws.amazon.com/',
        image: AwsIcon,
        vacantions: undefined,
      },
    ],
  },
]

export default sponsorsData2025
